import React, { useContext, useEffect, useState } from 'react'
import { getImages } from '../const'
import { Field, Form, Formik, FieldArray } from 'formik';
import ValidationError from '../Errors/ValidationError';
import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { VehicleContext } from '../Context/VehicleContext';
import { Link, useNavigate } from 'react-router-dom';

const OrderPartsModal = ({ close }) => {
    const {submitContactForm, vehicleListSearch, vehicleDecode, validateVIN} = useContext(VehicleContext);
    const recaptchaRef = React.useRef();
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        year: Yup.string().required('Vehicle Year is required'),
        make: Yup.string().required('Make is required'),
        model: Yup.string().required('Model is required'),
        mileage: Yup.string().required('Mileage is required'),
        full_name: Yup.string().required('Full Name is required'),
        email: Yup.string().email('Invalid email format').required('Email is required'),
        //marketing_agreement: Yup.bool().oneOf([true], 'Terms must be agreed to in order to submit your information'),
        //marketing_info_agreement: Yup.bool().oneOf([true], 'Terms must be agreed to in order to submit your information')
    });

    const partNeededBy = ['Today','Tomorrow','Within 1 Week','Anytime'];

    const paymentMethods = ['Cash','Credit Card','Have Payment Account','Other'];

    const states = ['AK','AL','AR','AS','AZ','CA','CO','CT','DC','DE','FL','GA','GU','HI','IA','ID','IL','IN','KS','KY','LA','MA','MD','ME','MI','MN','MO','MP','MS','MT','NC','ND','NE','NH','NJ','NM','NV','NY','OH','OK','OR','PA','PR','RI','SC','SD','TN','TX','UM','UT','VA','VI','VT','WA','WI','WV','WY'];

    const formikRef = React.useRef();
    
        const [vinData,setVinData] = useState(null);
    
        const onChangeVin = (e) => {
    
            if(validateVIN(e.target.value)) {
                getVINData(e.target.value);
            } 
            
            formikRef.current.setFieldValue('vin',e.target.value);
        }
    
        const getVINData = async (vin) => {
            const response = await vehicleDecode(vin);
    
            if('attributes' in response) {
                setVinData(response.attributes);
    
                formikRef.current.setFieldValue('year',response.attributes.Year);
    
                var data = await getVehicleYearData(response.attributes.Year);
    
                formikRef.current.setFieldValue('make',response.attributes.Make);
    
                var data = await getVehicleModels(response.attributes.Year,response.attributes.Make);
    
                formikRef.current.setFieldValue('model',response.attributes.Model);
    
            }
        }
    
        const [vehicleYears,setVehicleYears] = useState([]);
        const [vehicleMakes,setVehicleMakes] = useState([]);
        const [vehicleModels,setVehicleModels] = useState([]);
    
        const [vehicleYearData,setVehicleYearData] = useState([]);
    
        useEffect(() => {
    
            if(!vehicleYears || vehicleYears.length === 0) {
    
                getVehicleYears();
            }  
        },[]);
    
        const getVehicleYears = async () => {
            const data = await vehicleListSearch({'subject':'year'});
            console.log(data);
            setVehicleYears(data);
        }
    
        const getVehicleYearData = async (year) => {
            const data = await vehicleListSearch({'subject':'yeardata','year':year});
            console.log(data);
    
            setVehicleYearData(data);
            
            let makes = [];
            
            if('makes' in data) {
                data['makes'].map((make,i) => {
                    makes.push(make.name);
                });
    
                setVehicleMakes(makes);
            }
        }
    
        const getVehicleModels = async (year,make) => {        
            console.log(year,make);
    
            if('makes' in vehicleYearData) {
    
                let models = [];
    
                vehicleYearData['makes'].filter((item) => item.name == make).map((make,i) => {
                    console.log(make);
                    if('models' in make) {
                        make['models'].map((model,j) => {
                            models.push(model.name);
                        })
                    }
                });
    
                setVehicleModels(models);
            }
        }

    return (
        <>
            <div className="modal-content">
                <div className="modal-body ss-pd">
                    <button className="sm-box-close" type="button" onClick={close}>
                        <img src={getImages('white-close.svg')} />
                    </button>
                    <div className='xs-title font-1-9em text-lgray text-uppercase mb-4'>Order Parts</div>
                    <Formik
                        validationSchema={validationSchema}
                        innerRef={formikRef}
                        initialValues={{
                            year: '',
                            make: '',
                            model: '',
                            mileage: '',
                            vin: '',
                            part_needed_by: '',
                            customer_acct: '',
                            payment_method: '',
                            business_name: '',
                            comment: '',
                            parts_info: [
                                { part_number: '', part_description: '' }
                            ],
                            full_name: '',
                            email: '',
                            phone: '',
                            address: '',
                            city: '',
                            state: '',
                            zip_code: '',
                            service_form: true,
                            marketing_agreement: false,
                            marketing_info_agreement: false
                        }}
                        onSubmit={async (values, { resetForm }) => {
                            const token = await recaptchaRef.current.executeAsync();
                            recaptchaRef.current.reset(); // Reset after use

                            values.token = token;

                            console.log(values);
                            const data = await submitContactForm(values);

                            if (data.success) {
                                resetForm();
                                navigate("/thank-you");
                                // alert("Thank you for your submission. We'll be in touch soon!");
                                close();
                            } else
                                alert("There was a problem with your submission");
                        }}
                    >
                        {({ values, setFieldValue, field, form }) => (
                            <Form className="custom-form order-part-form row mlr-50" autoComplete="off" name="order-part-form">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6Ld25IorAAAAANZCaPfhdftOf511aOBscsnhKulz" // Replace with your actual site key
                                    size="invisible"
                                />
                                <Field type="hidden" name="service_form" value="true" />
                                <div className='col-12 mb-3 xs-title text-orange text-uppercase'>Vehicle Info</div>
                                <div className='col-md-6'>
                                    <div className='row gx-4'>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <div className='cs-label mb-1'>Vehicle Year</div>
                                                <Field
                                                    as="select"
                                                    name="year"
                                                    className="form-control"
                                                    onChange={(e) => { setFieldValue('year',e.target.value); getVehicleYearData(e.target.value); }}
                                                >
                                                    <option value="">Select</option>
                                                    {vehicleYears.map((v, i) => (
                                                        <option key={i} value={v}>
                                                            {v}
                                                        </option>
                                                    ))}
                                                </Field>
                                                <ValidationError name="year" />
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <div className='cs-label mb-1'>Make</div>
                                                <Field
                                                    as="select"
                                                    name="make"
                                                    className="form-control"
                                                    onChange={(e) => { setFieldValue('make',e.target.value); getVehicleModels(values.year,e.target.value); }}
                                                >
                                                    <option value="">Select</option>
                                                    {vehicleMakes.map((v, i) => (
                                                        <option key={i} value={v}>
                                                            {v}
                                                        </option>
                                                    ))}
                                                </Field>
                                                <ValidationError name="make" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='row gx-4'>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <div className='cs-label mb-1'>Model</div>
                                                <Field
                                                    as="select"
                                                    name="model"
                                                    className="form-control"
                                                >
                                                    <option value="">Select</option>
                                                    {vehicleModels.map((v, i) => (
                                                        <option key={i} value={v}>
                                                            {v}
                                                        </option>
                                                    ))}
                                                </Field>
                                                <ValidationError name="model" />
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <div className='cs-label mb-1'>Mileage</div>
                                                <Field
                                                    type="text"
                                                    name="mileage"
                                                    className="form-control"
                                                />
                                                <ValidationError name="mileage" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12'>
                                    <div className='form-group'>
                                        <div className='cs-label mb-1'>VIN</div>
                                        <Field
                                            type="text"
                                            name="vin"
                                            className="form-control"
                                            onChange={onChangeVin}
                                        />
                                    </div>
                                </div>
                                <div className='col-12'>
                                    <hr className='cs-hr' />
                                </div>
                                <div className='col-12 mb-3 xs-title text-orange text-uppercase'>Additional Info</div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='cs-label mb-1'>Part Needed By</div>
                                        <Field
                                            as="select"
                                            name="part_needed_by"
                                            className="form-control"
                                        >
                                            <option value="">Select</option>
                                            {partNeededBy.map((v,i) => (
                                                <option key={i} value={v}>{v}</option>
                                            ))}
                                        </Field>
                                        <ValidationError name="part_needed_by" />
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='cs-label mb-1'>Customer Acct #</div>
                                        <Field
                                            type="text"
                                            name="customer_acct"
                                            className="form-control"
                                        />
                                        <ValidationError name="customer_acct" />
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='cs-label mb-1'>Payment Method</div>
                                        <Field
                                            as="select"
                                            name="payment_method"
                                            className="form-control"
                                        >
                                            <option value="">Select</option>
                                            {paymentMethods.map((v,i) => (
                                                <option key={i} value={v}>{v}</option>
                                            ))}
                                        </Field>
                                        <ValidationError name="payment_method" />
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='cs-label mb-1'>Business Name</div>
                                        <Field
                                            type="text"
                                            name="business_name"
                                            className="form-control"
                                        />
                                        <ValidationError name="business_name" />
                                    </div>
                                </div>
                                <div className='col-12'>
                                    <div className='form-group'>
                                        <div className='cs-label mb-1'>Comments</div>
                                        <Field
                                            type="text"
                                            name="comment"
                                            className="form-control h-101"
                                            component="textarea" />
                                        <ValidationError name="comment" />
                                    </div>
                                </div>
                                <div className='col-12'>
                                    <hr className='cs-hr' />
                                </div>
                                <div className='col-12 mb-3 xs-title text-orange text-uppercase'>Parts Info</div>
                                {/* Part 1 */}
                                <FieldArray name="parts_info">
                                    {({ push, remove, form }) => (
                                        <>
                                            {form.values.parts_info.map((part, index) => (
                                                <React.Fragment key={index}>
                                                    <div className='col-md-4'>
                                                        <div className='form-group'>
                                                            <div className='cs-label mb-1'>Part Number {index + 1}</div>
                                                            <Field
                                                                type="text"
                                                                name={`parts_info[${index}].part_number`}
                                                                className="form-control"
                                                            />
                                                            <ValidationError name={`parts_info[${index}].part_number`} />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-8'>
                                                        <div className='form-group'>
                                                            <div className='cs-label mb-1'>Part Description</div>
                                                            <Field
                                                                type="text"
                                                                name={`parts_info[${index}].part_description`}
                                                                className="form-control"
                                                            />
                                                            <ValidationError name={`parts_info[${index}].part_description`} />
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            ))}

                                            <div className='col-12 text-end'>
                                                <button
                                                    type="button"
                                                    className="transparent-btn text-orange text-uppercase"
                                                    onClick={() => push({ part_number: '', part_description: '' })}
                                                >
                                                    <span className="plus-icon me-2"></span> Add Another Part
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </FieldArray>
                                <div className='col-12'>
                                    <hr className='cs-hr' />
                                </div>
                                <div className='col-12 mb-3 xs-title text-orange text-uppercase'>Contact Info</div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                            <div className='cs-label mb-0'>Full Name</div>
                                            <div className='text-required'><span className='text-orange'>*</span> Required</div>
                                        </div>
                                        <Field
                                            type="text"
                                            name="full_name"
                                            className="form-control"
                                        />
                                        <ValidationError name="full_name" />
                                    </div>
                                    <div className='form-group'>
                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                            <div className='cs-label mb-0'>Email</div>
                                            <div className='text-required'><span className='text-orange'>*</span> Required</div>
                                        </div>
                                        <Field
                                            type="text"
                                            name="email"
                                            className="form-control"
                                        />
                                        <ValidationError name="email" />
                                    </div>
                                    <div className='form-group'>
                                        <div className='cs-label mb-1'>Phone Number</div>
                                        <Field
                                            type="text"
                                            name="phone"
                                            className="form-control"
                                        />
                                        <ValidationError name="phone" />

                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='cs-label mb-1'>Address</div>
                                        <Field
                                            type="text"
                                            name="address"
                                            className="form-control"
                                        />
                                        <ValidationError name="address" />
                                    </div>
                                    <div className='form-group'>
                                        <div className='cs-label mb-1'>City</div>
                                        <Field
                                            type="text"
                                            name="city"
                                            className="form-control"
                                        />
                                        <ValidationError name="city" />
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <div className='cs-label mb-1'>State</div>
                                                <Field
                                                    as="select"
                                                    name="state"
                                                    className="form-control"
                                                >
                                                    <option value="">Select</option>
                                                    {states.map((v,i) => (
                                                        <option key={i} value={v}>{v}</option>
                                                    ))}
                                                </Field>
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div className='form-group'>
                                                <div className='cs-label mb-1'>Zip Code</div>
                                                <Field
                                                    type="text"
                                                    name="zip_code"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-12'>
                                    <div className="form-group marketing-agree">
                                        <div className="custom-checkbox fin_app_chkbox">
                                            <Field
                                                type="checkbox"
                                                name="marketing_agreement"
                                                // value="agree" 
                                                id="iAgreeChk"
                                            />
                                            <label htmlFor="iAgreeChk"  className="cs-label fw-400 font-12 pt-1">Yes, I agree to receive marketing/promotional SMS messages from McLaren Orlando, including special offers, exclusive incentives, event invitations, and dealership news.</label>
                                        </div>
                                        <ValidationError name="marketing_agreement"/>
                                    </div>
                                    <div className="form-group marketing-agree">
                                        <div className="custom-checkbox fin_app_chkbox">
                                            <Field
                                                type="checkbox"
                                                name="marketing_info_agreement"
                                                // value="agree" 
                                                id="iAgreeChk2"
                                            />
                                            <label htmlFor="iAgreeChk2"  className="cs-label fw-400 font-12 pt-1">Yes, I agree to receive informational/transactional SMS messages from McLaren Orlando, such as appointment reminders, service updates, vehicle status notifications, and important account-related information.</label>
                                        </div>
                                        <ValidationError name="marketing_info_agreement"/>
                                    </div>
                                    <div className="form-group">
                                        <div className="custom-checkbox fin_app_chkbox mb-4">
                                            <div  className="cs-label fw-400 font-12 pt-1 custom-breadcrumb">By providing your mobile number and checking the above box/es, you agree to related text messages from McLaren Orlando at the phone number you provided when signing up. Reply STOP to unsubscribe, Reply HELP for help. Message frequency varies. Message & data rates may apply. Consent is not a condition of purchase. For more information, please review our Privacy Policy <Link to="https://cars.mclaren.com/us_en/privacy-policy">Privacy Policy</Link> and <Link to="https://cars.mclaren.com/us_en/terms-conditions">Terms of Service</Link></div>
                                        </div>
                                    </div>
                                    <div className='text-end mt-3 mt-md-5'>
                                        <button type='submit' className='theme-btn text-uppercase d-inline-block'>Place Order</button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </>
    )
}

export default OrderPartsModal